import { cn } from '@lyearn/style';

import { StatusPillAppearance, StatusPillSize, StatusPillVariant } from './types';

const COMMON_OUTLINED_CLASSNAME = 'border border-solid bg-bg-primary';

const STATUS_PILL_SIZE_CLASSES = {
  large: 'px-12 h-32',
  medium: 'px-12 h-24',
  small: 'px-8 h-20',
};

const STATUS_PILL_TYPOGRAPHY_VARIANT = {
  large: 'label-02',
  medium: 'label-03',
  small: 'body-short-03',
};

const STATUS_PILL_COLOR_CLASSES = {
  filled: {
    cyan: 'bg-bg-cyan',
    danger: 'bg-bg-error',
    inverse: 'bg-interactive-white',
    pink: 'bg-bg-pink',
    primary: 'bg-bg-accent',
    purple: 'bg-bg-purple',
    secondary: 'bg-overlay',
    success: 'bg-bg-success',
    warning: 'bg-bg-warning',
  },
  light: {
    cyan: 'bg-bg-cyan-light',
    danger: 'bg-bg-error-light',
    inverse: 'bg-interactive-blur',
    pink: 'bg-bg-pink-light',
    primary: 'bg-bg-accent-light',
    purple: 'bg-bg-purple-light',
    secondary: 'bg-bg-tertiary',
    success: 'bg-bg-success-light',
    warning: 'bg-border-warning',
  },
  outlined: {
    cyan: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-cyan-dark'),
    danger: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-error-dark'),
    inverse: 'border border-solid bg-transparent border-interactive-white',
    pink: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-pink-dark'),
    primary: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-accent-dark'),
    purple: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-purple-dark'),
    secondary: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-dark'),
    success: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-success-dark'),
    warning: cn(COMMON_OUTLINED_CLASSNAME, 'border-border-warning-dark'),
  },
};

const STATUS_PILL_TYPOGRAPHY_COLOR_CLASSES = {
  filled: {
    cyan: 'text-text-white',
    danger: 'text-text-white',
    inverse: 'text-text-paragraph',
    pink: 'text-text-white',
    primary: 'text-text-white',
    purple: 'text-text-white',
    secondary: 'text-text-tertiary',
    success: 'text-text-white',
    warning: 'text-text-white',
  },
  light: {
    cyan: 'text-text-cyan',
    danger: 'text-text-error',
    inverse: 'text-text-white',
    pink: 'text-text-pink',
    primary: 'text-text-accent',
    purple: 'text-text-purple',
    secondary: 'text-text-secondary',
    success: 'text-text-success',
    warning: 'text-text-warning',
  },
  outlined: {
    cyan: 'text-text-cyan',
    danger: 'text-text-error',
    inverse: 'text-text-white',
    pink: 'text-text-pink',
    primary: 'text-text-accent',
    purple: 'text-text-purple',
    secondary: 'text-text-secondary',
    success: 'text-text-success',
    warning: 'text-text-warning',
  },
};

export const getStatusPillClasses = (
  size: StatusPillSize,
  variant: StatusPillVariant,
  appearance: StatusPillAppearance,
) => {
  const sizeClasses = STATUS_PILL_SIZE_CLASSES[size];
  const typographyVariant = STATUS_PILL_TYPOGRAPHY_VARIANT[size];
  const colorClasses = STATUS_PILL_COLOR_CLASSES[variant][appearance];
  const typographyColorClass = STATUS_PILL_TYPOGRAPHY_COLOR_CLASSES[variant][appearance];

  return {
    label: 'p-0',
    root: cn('rounded-full', colorClasses, sizeClasses, typographyColorClass, typographyVariant),
  };
};
